import { render, staticRenderFns } from "./libraryView.vue?vue&type=template&id=4863f044"
import script from "./libraryView.vue?vue&type=script&lang=js"
export * from "./libraryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports